import * as React from "react";
const SvgFiRrFabric = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-fabric_svg__a)">
      <path
        fill="#062147"
        d="M12 9a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1m-7-.667a1 1 0 0 0 1-1V1a1 1 0 1 0-2 0v6.333a1 1 0 0 0 1 1m3.657-.982A8.8 8.8 0 0 0 12 8a8.8 8.8 0 0 0 3.343-.649c.397-.159.657-.542.657-.969 0-.742-.764-1.26-1.44-.955-.759.343-1.56.572-2.56.572s-1.801-.229-2.56-.572C8.763 5.122 8 5.639 8 6.382c0 .427.26.81.657.969M19 8.333a1 1 0 0 0 1-1V1a1 1 0 1 0-2 0v6.333a1 1 0 0 0 1 1M22 5h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2M1 5h1a1 1 0 0 0 0-2H1a1 1 0 0 0 0 2m11 0a1 1 0 0 0 1-1V1a1 1 0 1 0-2 0v3a1 1 0 0 0 1 1m-2.5 7.194c0-.369-.2-.828-.529-.996a25 25 0 0 1-1.045-.575C6.597 9.862 5.09 9 3 9H1a1 1 0 0 0 0 2h2c1.292 0 2.239.541 3.436 1.227.508.291 1.04.595 1.623.867.669.313 1.441-.161 1.441-.9m9.5.452a1 1 0 0 0-1 1V23a1 1 0 1 0 2 0v-9.354a1 1 0 0 0-1-1M23 15h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2m0-6h-2c-2.09 0-3.597.862-4.926 1.623-.356.204-.7.399-1.045.575-.329.168-.529.627-.529.996 0 .739.771 1.213 1.441.9a22 22 0 0 0 1.623-.867C18.761 11.541 19.708 11 21 11h2a1 1 0 0 0 0-2M12 21a1 1 0 0 0-1 1v1a1 1 0 1 0 2 0v-1a1 1 0 0 0-1-1m-7-8.354a1 1 0 0 0-1 1V23a1 1 0 1 0 2 0v-9.354a1 1 0 0 0-1-1M2 15H1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2m12.56 2.428C13.801 17.771 13 18 12 18s-1.801-.229-2.56-.572c-.677-.305-1.44.212-1.44.955 0 .427.26.81.657.969a8.8 8.8 0 0 0 3.343.649 8.8 8.8 0 0 0 3.343-.649c.397-.159.657-.542.657-.969 0-.742-.764-1.26-1.44-.955"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-fabric_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFabric;
